// src/pages/admin/AddTent.jsx
import React, { useState } from "react";
import { ref, push } from "firebase/database";
import { dimaniwasRtdb } from "../../firebase/config"; // Use Dimaniwas DB
import styles from "./addproducts.module.css";

const AddTent = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [tent, setTent] = useState({
    name: "",
    slug: "",
    description: "",
    price: ""
  });
  const [imageUrl, setImageUrl] = useState("");

  // Generate slug automatically from name
  const generateSlug = (name) =>
    name.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "");

  const handleNameChange = (e) => {
    const name = e.target.value;
    setTent((t) => ({ ...t, name, slug: generateSlug(name) }));
  };

  // Cloudinary image upload
  const handleUpload = () => {
    window.cloudinary.openUploadWidget(
      {
        cloudName: "dev-binudstorage",
        uploadPreset: "mrittika_unsigned",
        sources: ["local"],
        multiple: false
      },
      (error, result) => {
        if (!error && result.event === "success") {
          console.log("Image uploaded:", result.info.secure_url);
          setImageUrl(result.info.secure_url);
        } else if (error) {
          console.error("Cloudinary upload error:", error);
        }
      }
    );
  };

  // Save tent to Firebase Realtime Database
  const handleSave = () => {
    const { name, slug, description, price } = tent;

    if (!name || !slug || !description || !price || !imageUrl) {
      alert("Please fill all required fields");
      console.log("Validation failed:", { name, slug, description, price, imageUrl });
      return;
    }

    const tentData = {
      name,
      slug,
      description,
      price: Number(price),
      image: imageUrl,
      createdAt: Date.now() // ✅ Add timestamp for Dashboard counters
    };

    console.log("Tent data to push:", tentData);

    const tentsRef = ref(dimaniwasRtdb, "tents");

    push(tentsRef, tentData)
      .then((snapshot) => {
        console.log("Tent successfully saved with key:", snapshot.key);
        alert("Tent added successfully!");
        // Reset form
        setTent({ name: "", slug: "", description: "", price: "" });
        setImageUrl("");
      })
      .catch((error) => {
        console.error("Error saving tent:", error);
        alert("Failed to save tent. Check console for details.");
      });
  };

  return (
    <div className={`d-flex flex-column flex-md-row ${styles.container}`}>
      {/* Mobile menu toggle */}
      <button className="btn btn-dark d-md-none m-2" onClick={() => setSidebarOpen(!sidebarOpen)}>
        ☰ Menu
      </button>

      {/* Sidebar */}
      <div className={`bg-dark text-white p-4 ${styles.sidebar} ${sidebarOpen ? "d-block" : "d-none"} d-md-block`}>
        <h2 className={styles.logo}>Admin</h2>
        <ul className="nav flex-column admin_dashboard">
          <li><a href="/admin/dashboard" className="nav-link text-white">Dashboard</a></li>
          <li><a href="/admin/add-tent" className="nav-link text-warning">Add Tent</a></li>
          <li><a href="/admin/all-tents" className="nav-link text-white">Manage Tents</a></li>
          <li><a href="/admin/add-feature" className="nav-link text-white">Add Feature</a></li>
          <li><a href="/admin/all-features" className="nav-link text-white">All Features</a></li>
        </ul>
      </div>

      {/* Main Content */}
      <div className={`p-4 w-100 ${styles.main}`}>
        <h2 className={styles.addProduct_title}>Add Tent</h2>

        <div className={styles.form}>
          <div className={styles.formGroup}>
            <label>Tent Name</label>
            <input type="text" value={tent.name} onChange={handleNameChange} className={styles.input} />
          </div>

          <div className={styles.formGroup}>
            <label>Slug</label>
            <input type="text" value={tent.slug} readOnly className={`${styles.input} ${styles.readonly}`} />
          </div>

          <div className={styles.formGroup}>
            <label>Description</label>
            <textarea value={tent.description} onChange={(e) => setTent((t) => ({ ...t, description: e.target.value }))} className={styles.textarea} />
          </div>

          <div className={styles.formGroup}>
            <label>Price (per night)</label>
            <input type="number" value={tent.price} onChange={(e) => setTent((t) => ({ ...t, price: e.target.value }))} className={styles.input} />
          </div>

          <div className={styles.imageUploadBox}>
            <label>Upload Tent Image</label>
            <button onClick={handleUpload} className={styles.uploadButton}>Upload Image</button>
            {imageUrl && <div className={styles.imagePreviewWrapper}><img src={imageUrl} alt="Preview" className={styles.imagePreview} /></div>}
          </div>

          <button onClick={handleSave} className={styles.saveButton}>Save Tent</button>
        </div>
      </div>
    </div>
  );
};

export default AddTent;
